/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.settlement.detail.controllers', [
    'ui.router',
    'acme.common.service.api'
])

.controller('SettlementDetailController', ['$scope',  '$state', 'ApiService', 'CompanyData', function($scope, $state, ApiService, CompanyData) {

        $scope.data = {};
        $scope.transactions = {};

        $scope.detail = {

            currentId: null,

            tenant: null,

            paging: {
                pageSize: 25,
                currentPage: 1,
                totalItems: 0,
                totalPages: 1,

                next: function() {
                    if ( this.currentPage < this.totalPages ) {
                        this.currentPage++;
                        $scope.detail.transactionList($state.params.id, this.currentPage);
                    }
                },

                previous: function() {
                    if ( this.currentPage > 1 ) {
                        this.currentPage--;
                        $scope.detail.transactionList($state.params.id, this.currentPage);
                    }
                }
            },

            init: function() {

                if ($state.params && $state.params.id) {
                    this.currentId = $state.params.id;
                    this.get($state.params.id);

                    $scope.$emit('Application::contentTitleChange', {
                        title: 'Settlement Detail',
                        buttonLeft: {
                            label: 'Back to List',
                            action: function() {
                                $state.go('application.settlement.list');
                            }
                        }
                    });

                    if ( CompanyData && CompanyData.data.success ) {
                        this.success.init(CompanyData);
                    } else {
                        this.error.init(CompanyData);
                    }
                }
            },

            get: function(id) {
                ApiService.settlements.get(id).then(this.success.get, this.error.get);
            },

            transactionList: function(id, page) {
                ApiService.settlements.transactions.list(id, page).then(this.success.transactions.list, this.error.transactions.list);
            },

            success: {
                init: function(cd) {
                    $scope.detail.tenant = cd.data.tenant;
                },

                get: function(response) {
                    $scope.data = response.data.payload;
                    $scope.data.invoiceNum = $state.params.id;

                    console.log("data", $scope.data);

                    $scope.detail.transactionList($state.params.id, $scope.detail.paging.currentPage);
                },

                transactions: {
                    list: function(response) {
                        $scope.transactions = response.data.payload;
                        $scope.detail.paging.totalPages = $scope.transactions.totalPages;
                    }
                }
            },

            error: {
                init: function(cd) {

                },

                get: function(response) {

                },

                transactions: {
                    list: function(response) {

                    }
                }
            }


        };

        $scope.detail.init();

}]);